/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { ClientAddOnService } from './client-add-on.service';
import { AuthService } from './auth.service';
import { CarriersService } from './carriers.service';
import { ClientService } from './client.service';
import { CompanyService } from './company.service';
import { ContactInfoService } from './contact-info.service';
import { ExcelService } from './excel.service';
import { InvoiceService } from './invoice.service';
import { InvoiceFailureService } from './invoice-failure.service';
import { SaasInvoiceReportService } from './saas-invoice-report.service';
import { ZuumMatchMediaService } from './match-media.service';
import { ScriptService } from './script.service';
import { UserService } from './user.service';
import { UserPermissionService } from './user-permission.service';
import { UtilsService } from './utils.service';
import { UtilsApiService } from './utils-api.service';
import { ValidatorsService } from './validators.service';
import { PriceConfigService } from './price-config.service';
import { PaymentMethodsService } from './payment-methods.service';
import { SuperAdminUserService } from './super-admin-user.service';
import { BrandingService } from './branding.service';
import { ThemingService } from './theming.service';
import { ClusterService } from './cluster.service';
import { GlobalPriceConfigurationService } from './global-price-configuration.service';
import { LocalStorageService } from './library/local-storage.service';
import { ClientPlanService } from './client-plan.service';
import { StripeSAService } from './stripe.service';
import { GlobalPriceConfigurationPriceTypeService } from './global-price-configuration-price-type.service';
import { PriceConfigPriceTypeService } from './price-config-price-type.service';
import { ActivityLogService } from './activity-log.service';

export const services: any[] = [
  ClientAddOnService,
  AuthService,
  CarriersService,
  PriceConfigService,
  PriceConfigPriceTypeService,
  ClientService,
  CompanyService,
  ContactInfoService,
  ExcelService,
  InvoiceService,
  PaymentMethodsService,
  ScriptService,
  UserService,
  UserPermissionService,
  UtilsService,
  UtilsApiService,
  ValidatorsService,
  ZuumMatchMediaService,
  SuperAdminUserService,
  BrandingService,
  ThemingService,
  ClusterService,
  GlobalPriceConfigurationService,
  GlobalPriceConfigurationPriceTypeService,
  LocalStorageService,
  ClientPlanService,
  StripeSAService,
  ActivityLogService,
  SaasInvoiceReportService,
  InvoiceFailureService,
];

export * from './client-add-on.service';
export * from '../../services/api.service';
export * from './auth.service';
export * from './carriers.service';
export * from './company.service';
export * from './contact-info.service';
export * from './price-config.service';
export * from './price-config-price-type.service';
export * from './client.service';
export * from './excel.service';
export * from './invoice.service';
export * from './invoice-failure.service';
export * from './saas-invoice-report.service';
export * from './invoice-item-customization.service';
export * from './match-media.service';
export * from './payment-methods.service';
export * from './script.service';
export * from './user.service';
export * from './user-permission.service';
export * from './utils.service';
export * from './utils-api.service';
export * from './validators.service';
export * from './super-admin-user.service';
export * from './branding.service';
export * from './theming.service';
export * from './cluster.service';
export * from './global-price-configuration.service';
export * from './global-price-configuration-price-type.service';
export * from './client-plan.service';
export * from './stripe.service';
export * from './contact-info.service';
export * from './activity-log.service';
export * from './usage-report.service';
export * from './client-document.service';
export * from './base-storage.service';
export * from './plan.service';
export * from './api-management.service';
export * from './tenant-api-management.service';
